//Pour communiquer avec le service worker

export async function sendMessage(message) {
  const registration = await navigator.serviceWorker.ready;

  return new Promise((resolve, reject) => {
    const messageChannel = new MessageChannel();

    // Set up listener for the response
    messageChannel.port1.onmessage = (event) => {
      if (event.data.error) {
        reject(event.data.error);
      } else {
        resolve(event.data);
      }
    };

    // Send the message to the service worker via port2
    if (registration.active) {
      registration.active.postMessage(message, [messageChannel.port2]);
    } else {
      reject("No active service worker found.");
    }
  });
}
